import { PaletteMode, PaletteOptions, alpha } from '@mui/material';
import { blue, grey, white } from './colors';

export const background = (mode: PaletteMode): PaletteOptions['background'] => {
  return mode === 'light'
    ? {
        navigation: grey[850],
        overlay: alpha(grey[950], 0.7),
        default: white,
        paper: grey[50],
        tooltip: grey[900],
        popover: white,
        canvas: grey[50],
        container: white,
        hover: grey[50],
        selected: blue[50],
      }
    : {
        navigation: grey[850],
        overlay: alpha(grey[850], 0.7),
        default: grey[900],
        paper: grey[850],
        tooltip: grey[850],
        popover: grey[850],
        canvas: grey[950],
        container: grey[900],
        hover: grey[800],
        selected: blue[850],
      };
};
